export enum Interest {
  WEB = 'Web',
  MOBILE = 'Mobile',
  CLOUD = 'Cloud',
  DESIGN = 'UX/UI Design',
  QA = 'QA',
  QA_AUTOMATION = 'QA Automation',
  MANAGEMENT = 'Management',
}
